import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
// import DisRoutes from "@/routes/routes";
import DisRoutes from "@/routes/DisRoutes"
import styles from "./Navbar.module.scss";
import { combineClasses, getCurrentUser, getItem } from "@/lib/utils";
import { FaBars, FaUserCircle } from "react-icons/fa";
import {
  Checkin,
  checkout,
  getUserGlobalSetting,
  getUsersSetting,
} from "@/store/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch } from "@/store/store";
export interface SelectOption {
  label: string;
  value: string;
}
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { motion, AnimatePresence } from "framer-motion";
import ProfileDropdown from "@/components/User/profile-dropdown/ProfileDropdown";
import { getRole } from "@/services/axios";
dayjs.extend(customParseFormat);
interface NavbarProps {
  toggleSidebar: () => void;
}
// inside your component
const Navbar: React.FC<NavbarProps> = ({ toggleSidebar }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [currentUser, SetCurrentUer] = useState<any>({});
  const timerRef = useRef<number | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const sidebarRef = useRef<HTMLDivElement>(null);

  const username = getItem("username");

  useEffect(() => {
    SetCurrentUer(getCurrentUser());
  }, [dispatch]);
 
//  useEffect(() => {
//   const handleClickOutside = (event: MouseEvent) => {
//     const isMobile = window.innerWidth <= 768;

//     if (
//       isMobile &&
//       sidebarRef.current &&
//       !sidebarRef.current.contains(event.target as Node)
//     ) {
//       toggleSidebar(); // close sidebar
//     }
//   };

//   document.addEventListener("mousedown", handleClickOutside);

//   return () => {
//     document.removeEventListener("mousedown", handleClickOutside);
//   };
// }, [toggleSidebar]);

  const isRetailer = getRole() === "retailer";
  const getInitials = (name: string) => {
    if (!name) return "U";
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  return (
    <div className={styles.topBarContainer}>
      <div className={styles.leftSide}>
        <FaBars
          className={styles.hamburger}
          onClick={toggleSidebar}
        />
      <div style={{ fontFamily: "DM Sans", fontWeight: 700, fontSize: "1.25rem", lineHeight: "100%", textAlign: "center" }}>
                <span style={{ color: "#4A6FF4" }}>{isRetailer ? 'Retailer' : 'Distributor'} </span>
                <span style={{ color: "#000000" }}>Portal</span>
            </div>
      </div>

      <div className={styles.rightSide}>
        
        <div className={styles.userSection}>
          <button
            ref={buttonRef}
            className={`${styles.userName} ${isOpen ? styles.active : ""}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="text-gray-600 font-[550]">
              {username || "XYZ"}
            </span>
            <div className={styles.avatarCircle}>
              {getInitials(username || "XYZ")}
            </div>

            <span className={styles.dropdownArrow}>▾</span>
          </button>

          <AnimatePresence>
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 50 }}
                transition={{ duration: 0.25, ease: "easeOut" }}
                className="absolute right-3 top-full mt-2 rounded-[15px] shadow-2xl z-50 bg-white"
                onClick={(e) => e.stopPropagation()}
              >
                <ProfileDropdown />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default memo(Navbar);
